module.exports = __webpack_public_path__ + "img/strategy4.09c41c59.png";